import { useState, useEffect } from "react";
import { getRoles } from "../../../services/userService";

const EMPTY_FORM = {
  name: "",
  email: "",
  role: "",
  address: "",
  phone: "",
};

export default function UserModal({
  onClose,
  onSaved,
  editData,
}) {
  const [form, setForm] = useState(editData || EMPTY_FORM);

  const [roles, setRoles] = useState([]);
  const [loadingRoles, setLoadingRoles] = useState(true);

  const [errors, setErrors] = useState({}); //  FIELD ERRORS

  //  editData sync
  useEffect(() => {
    setForm(editData || EMPTY_FORM);
  }, [editData]);

  // FETCH ROLES
  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const res = await getRoles();
        setRoles(res?.data || []);
      } catch (err) {
        console.error("Role fetch error:", err);
      } finally {
        setLoadingRoles(false);
      }
    };

    fetchRoles();
  }, []);

  const handleChange = (field) => (e) => {
    setForm((p) => ({ ...p, [field]: e.target.value }));
    setErrors((p) => ({ ...p, [field]: "" })); //  clear error
  };

  // VALIDATION
  const validate = () => {
    const e = {};

    if (!form.name.trim()) e.name = "Name is required.";
    if (!form.email.trim()) e.email = "Email is required.";
    if (!form.phone.trim()) e.phone = "Phone is required.";

    return e;
  };

  const handleSubmit = () => {
    const e = validate();

    if (Object.keys(e).length) {
      setErrors(e); //  show field errors
      return;
    }

    onSaved(form, !!editData);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        
        {/* HEADER */}
        <div className="modal-header">
          <div className="modal-title">
            {editData ? "Edit User" : "Add User"}
          </div>
          <button className="modal-close" onClick={onClose}>
            ✕
          </button>
        </div>

        {/* BODY */}
        <div className="modal-body">
          
          {/* NAME */}
          <div className="org-form-row" style={{ gridTemplateColumns: "1fr" }}>
            <div className="org-form-field">
              <label className="org-field-label">
                Name <span className="req">*</span>
              </label>
              <input
                className={`org-field-input ${errors.name ? "input-error" : ""}`}
                value={form.name}
                onChange={handleChange("name")}
              />
              {errors.name && (
                <span className="field-error">⚠ {errors.name}</span>
              )}
            </div>
          </div>

          {/* EMAIL */}
          <div className="org-form-row" style={{ gridTemplateColumns: "1fr" }}>
            <div className="org-form-field">
              <label className="org-field-label">
                Email <span className="req">*</span>
              </label>
              <input
                className={`org-field-input ${errors.email ? "input-error" : ""}`}
                value={form.email}
                onChange={handleChange("email")}
              />
              {errors.email && (
                <span className="field-error">⚠ {errors.email}</span>
              )}
            </div>
          </div>

          {/* PHONE */}
          <div className="org-form-row" style={{ gridTemplateColumns: "1fr" }}>
            <div className="org-form-field">
              <label className="org-field-label">
                Phone <span className="req">*</span>
              </label>
              <input
                className={`org-field-input ${errors.phone ? "input-error" : ""}`}
                value={form.phone}
                onChange={handleChange("phone")}
              />
              {errors.phone && (
                <span className="field-error">⚠ {errors.phone}</span>
              )}
            </div>
          </div>

          {/* ROLE */}
          <div className="org-form-row" style={{ gridTemplateColumns: "1fr" }}>
            <div className="org-form-field">
              <label className="org-field-label">Role</label>

              <select
                className="org-field-input"
                value={form.role}
                onChange={handleChange("role")}
                disabled={loadingRoles}
              >
                <option value="">
                  {loadingRoles ? "Loading roles..." : "Select Role"}
                </option>

                {roles.map((r) => (
                  <option key={r.id} value={r.id}>
                    {r.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* ADDRESS */}
          <div className="org-form-row" style={{ gridTemplateColumns: "1fr" }}>
            <div className="org-form-field">
              <label className="org-field-label">Address</label>
              <textarea
                className="org-field-input"
                value={form.address}
                onChange={handleChange("address")}
                rows={3}
              />
            </div>
          </div>

        </div>

        {/* FOOTER */}
        <div className="modal-footer">
          <button className="org-btn-cancel" onClick={onClose}>
            Cancel
          </button>

          <button className="org-btn-save" onClick={handleSubmit}>
            {editData ? "Update" : "Add"}
          </button>
        </div>

      </div>
    </div>
  );
}